import { observer } from 'mobx-react';
import React from 'react';

import DateRangePickerWithSearchParams from 'components/DatePicker/Range/WithSearchParams';

import GradeBookMonthHeaderProgramAutocomplete from './ProgramAutocomplete';
import { Wrapper } from './styled';

function GradeBookMonthHeader() {
	return (
		<Wrapper>
			<DateRangePickerWithSearchParams />
			<GradeBookMonthHeaderProgramAutocomplete />
		</Wrapper>
	);
}

export default observer(GradeBookMonthHeader);
